<script lang="ts">
    export let icon="";
    export let class_list: Array<string> = [];
</script>
<i class="material-icons {class_list.join(" ")}">{icon}</i>
